/* tslint:disable */
/* eslint-disable */
/**
 * Main API v1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CanDisableOffreResultDto
 */
export interface CanDisableOffreResultDto {
    /**
     * 
     * @type {boolean}
     * @memberof CanDisableOffreResultDto
     */
    canDisable?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CanDisableOffreResultDto
     */
    offreActive?: boolean;
    /**
     * 
     * @type {number}
     * @memberof CanDisableOffreResultDto
     */
    idOffre?: number | null;
    /**
     * 
     * @type {string}
     * @memberof CanDisableOffreResultDto
     */
    remarque?: string | null;
}

/**
 * Check if a given object implements the CanDisableOffreResultDto interface.
 */
export function instanceOfCanDisableOffreResultDto(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function CanDisableOffreResultDtoFromJSON(json: any): CanDisableOffreResultDto {
    return CanDisableOffreResultDtoFromJSONTyped(json, false);
}

export function CanDisableOffreResultDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): CanDisableOffreResultDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'canDisable': !exists(json, 'canDisable') ? undefined : json['canDisable'],
        'offreActive': !exists(json, 'offreActive') ? undefined : json['offreActive'],
        'idOffre': !exists(json, 'idOffre') ? undefined : json['idOffre'],
        'remarque': !exists(json, 'remarque') ? undefined : json['remarque'],
    };
}

export function CanDisableOffreResultDtoToJSON(value?: CanDisableOffreResultDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'canDisable': value.canDisable,
        'offreActive': value.offreActive,
        'idOffre': value.idOffre,
        'remarque': value.remarque,
    };
}

